export default {"src":"/_next/static/media/youtube.9db07b2c.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};